import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AccountContext } from '../../../../components/AccountContext';

const InsufficientCreditsForRetentionFeePaidBySelf = ({ visible, insufficientCreditsData }) => {
  const currentAccount = useContext(AccountContext);
  const history = useHistory();

  return (
    <Dialog
      header="Your Credits balance is low"
      dismissableMask={false}
      closable={false}
      blockScroll={true}
      visible={visible}
      onHide={() => {}}
      position="center"
    >
      <p>{`Your Credits balance is ${insufficientCreditsData.creditBalance} which is not enough to pay the retention fee of ${insufficientCreditsData.retentionPrice} Credits`}</p>
      <p>Please buy more credits</p>
      <div className="center">
        <Button
          type="button"
          className="p-button-primary"
          label="BUY CREDITS"
          onClick={() => history.push(`/accounts/${currentAccount}/buy-credits`)}
        />
      </div>
      <p>If you need assistance, please contact your GPI representative:</p>
      <p>Name: {`${insufficientCreditsData.gpiRepresentative.parentAccountOwnerFullName}`}</p>
      <p>Email: {insufficientCreditsData.gpiRepresentative.parentAccountOwnerEmail}</p>
    </Dialog>
  );
};

export default InsufficientCreditsForRetentionFeePaidBySelf;
